import { render, staticRenderFns } from "./WidgetPublicView.vue?vue&type=template&id=455a2821&scoped=true"
import script from "./WidgetPublicView.vue?vue&type=script&lang=js"
export * from "./WidgetPublicView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455a2821",
  null
  
)

export default component.exports